<script lang="ts">
    import type {BasicUser, User} from 'typings/portaro.be.types';
    import {minidenticon} from 'minidenticons';
    import {exists} from 'shared/utils/custom-utils';

    export let user: User | BasicUser | null;
    export let sizePx: number;
    export let inline = false;

    export let userName = user?.text;
    export let userId: string | number = user?.id;

    if (!exists(user) && !userName && !userId) {
        throw new Error('Invalid component data! Either `user` or both `userName` and `userId` should be set!');
    }

    $: svgURI = `data:image/svg+xml;utf8,${encodeURIComponent(minidenticon((typeof userId === 'number' ? userId.toString(10) : userId), 95, 45))}`;
</script>

<span class="kp-user-avatar"
      class:is-inline={inline}
      style:--size="{sizePx}px">

    <img src="{svgURI}" alt="{userName}"/>
</span>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    .kp-user-avatar {
        display: block;
        pointer-events: none;
        border: 1px solid @themed-border-default;
        background-color: @themed-body-bg;
        overflow: hidden;
        width: var(--size);
        height: var(--size);
        flex-grow: 0;
        flex-shrink: 0;
        border-radius: calc(var(--size) / 2);

        img {
            width: 100%;
            height: 100%;
        }

        &.is-inline {
            display: inline-block;
        }
    }
</style>